import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "owa-accounts-store", webpackPrefetch: true */ './lazyIndex')
);

export const lazyInitializeOwaAccountsStore = new LazyAction(
    lazyModule,
    m => m.initializeOwaAccountsStore
);

export {
    addOWAConnectedAccount,
    removeOWAConnectedAccount,
    connectOWAAccount,
    disconnectOWAAccount,
    updateOWAConnectedAccountToken,
} from './actions';
export * from './selectors';
export { default as getUserConfigurationForMailbox } from './utils/getUserConfigurationForMailbox';
export { isConnectedAccount } from './utils/isConnectedAccount';

export { OWAConnectedAccount, AccountProviderType } from './schema/OWAConnectedAccount';
